import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { Label } from '@bingads-webui-react/fabric-control';
import { thridPartyMeasurementTrackingStyles } from '../../styles/third-party-measurement-setting-styles';

export const AccountLinkedStatusLabel = ({ doubleVerifyLinkEstablished, i18n, overrideStyle }) => {
  let statusMessage = i18n.getString(_TL_('Unknown  status'));
  if (!doubleVerifyLinkEstablished) {
    statusMessage = i18n.getString(_TL_('Not activated'));
  } else {
    statusMessage = i18n.getString(_TL_('Activated'));
  }
  const style = useMemo(() => ({
    ...thridPartyMeasurementTrackingStyles.label({ linked: doubleVerifyLinkEstablished }),
    ...overrideStyle,
  }), [overrideStyle, doubleVerifyLinkEstablished]);

  return (
    <Label
      style={style}
      className={doubleVerifyLinkEstablished ? 'account-linked-status-label' : 'account-not-linked-status-label'}
    >
      {statusMessage}
    </Label>
  );
};

AccountLinkedStatusLabel.propTypes = {
  doubleVerifyLinkEstablished: PropTypes.bool.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  overrideStyle: PropTypes.shape({}),
};

AccountLinkedStatusLabel.defaultProps = {
  overrideStyle: {},
};

